import * as React from "react";
import type { SVGProps } from "react";
const ElectricalServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_5960)">
      <path
        fill="currentColor"
        d="M8.5 0C7.6703 0 7 .6703 7 1.5V6h3V1.5C10 .6703 9.3297 0 8.5 0m9 0c-.8297 0-1.5.6703-1.5 1.5V6h3V1.5c0-.8297-.6703-1.5-1.5-1.5m-12 7.5C4.6703 7.5 4 8.1703 4 9s.6703 1.5 1.5 1.5V12c0 3.6281 2.5781 6.6562 6 7.35v3.15c0 .8297.6703 1.5 1.5 1.5s1.5-.6703 1.5-1.5v-3.15c3.4219-.6938 6-3.7219 6-7.35v-1.5c.8297 0 1.5-.6703 1.5-1.5s-.6703-1.5-1.5-1.5z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_5960">
        <path fill="transparent" d="M4 0h18v24H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default ElectricalServices;
